import { Component } from '@angular/core';

@Component({
  selector: 'app-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['../../../../theme/agent.scss', './tiles.component.scss'],
})
export class TilesComponent {}
